import type { SVGProps } from 'react';
const SvgIconDisclosureRight = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.122 13.808a.743.743 0 0 1-.052-1.05L9.13 8 5.07 3.242a.743.743 0 1 1 1.102-.997L10.93 7.5a.743.743 0 0 1 0 .998l-4.758 5.256a.743.743 0 0 1-1.05.053"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconDisclosureRight;
